import {
  QuestionExamGradeFilter,
  listQuestionExamGrades,
} from '@/data/services/questionExamGradeServices';

export const questionExamGradeQueries = {
  all: ['question-exam-grades'] as const,

  list: (filters: QuestionExamGradeFilter = {}) => ({
    queryKey: [
      ...questionExamGradeQueries.all,
      'list',
      { filters },
    ] as const,
    queryFn: () => listQuestionExamGrades(filters),
  }),
};
